<template>
    <div class="hero">
        <!-- <div class="container"> -->
        <div class="hero-head">
            <h1 class="title">To-dos can be found here!</h1>
        </div>
        <div class="hero-body">
            <b-table :data="onlyChecked?uncheckedRows:todosArray" ref="table" striped default-sort-direction="asc"
                default-sort="date" detailed detail-key="ID" :opened-detailed="isToggled?detailed:[]"
                :show-detail-icon=false checkable checkbox-position="left" :checked-rows.sync="checkedRows"
                :is-row-checkable="!isAdmin?(row) => row.id:() => 'none'">
                <template slot-scope="props">
                    <b-table-column field="ID" label="ID" :visible=false>{{ props.row.ID }}</b-table-column>
                    <b-table-column field="Date" label="Date">{{ dateToOrder(props.row.Date) | orderToHuman }}
                    </b-table-column>
                    <b-table-column field="Art" label="Type" sortable>{{ props.row.Art }}</b-table-column>
                    <b-table-column field="Person" label="Person" sortable>{{ props.row.Person }} </b-table-column>
                    <b-table-column field="Raum" label="Room" sortable>{{ props.row.Raum }}</b-table-column>
                    <b-table-column field="Rechner" label="Computer" sortable>{{ props.row.Rechner }}</b-table-column>
                    <b-table-column field="ID" label="Details" centered>
                        <template slot="header" slot-scope="{ column }">
                            <b-tooltip :label="isToggled?'Close ' + column.label:'Open ' + column.label">
                                <a @click="toggleAll()"> {{ column.label }} <b-icon icon="angle-right"
                                        :class="isToggled?'open':'closed'" size="is-small"></b-icon></a>
                            </b-tooltip>
                        </template>
                        <a @click="toggle(props.row)" v-if="props.row.Details">
                            <b-icon icon="angle-right" :class="showRow(props.row)"></b-icon>
                        </a>
                        <b-icon icon="angle-down" type="is-light" v-else></b-icon>
                    </b-table-column>
                </template>
                <template slot="detail" slot-scope="props">
                    <article class="media">
                        <div class="media-content">
                            <div class="content">
                                <p>
                                    {{ props.row.Details }}
                                </p>
                            </div>
                            <div class="wrapper" v-if="props.row.Notes">
                                <article class="media" :key="note.ID" v-for="note in props.row.Notes">
                                    <div class="media-content">
                                        <div class="content">
                                                <div class="control">{{ note.Note }}
                                                </div>
                                            <b-field grouped>
                                                <b-tag type="is-light" size="is-medium"> – {{ note.Person}}</b-tag> &nbsp; 
                                                <div class="control">
                                                    <b-taglist attached>
                                                        <b-tag type="is-white" size="is-medium">
                                                            {{ dateToOrder(note.Date) | orderToHuman }}
                                                        </b-tag>
                                                        <b-tag type="is-white" size="is-medium">{{ note.Time | timeToHuman }}</b-tag>
                                                    </b-taglist>
                                                </div>
                                            </b-field>
                                        </div>
                                    </div>
                                </article>
                            </div>
                        </div>
                    </article>
                    <AddNote :ID="props.row.ID"></AddNote>
                </template>
                <template slot="empty">
                    <section class="section">
                        <div class="content has-text-grey has-text-centered">
                            <p>
                                <b-icon icon="sad-tear" size="is-large">
                                </b-icon>
                            </p>
                            <p>Nothing here.</p>
                        </div>
                    </section>
                </template>
            </b-table>
        </div>
        <div class="hero-foot">
            <transition name="fade" mode="out-in" appear>
                <div class="section" v-if="showFilters">
                    <div class="container">
                        <div class="columns">
                            <div class="column">
                                <b-field label="Date">
                                    <b-datepicker placeholder="Click..." v-model="filterDates" range
                                        :mobile-native="false">
                                        <div class="buttons is-right">
                                            <button class="button is-danger is-fullwidth"
                                                @click.prevent="filterDates = null">
                                                <b-icon icon="times-circle"></b-icon>
                                                <span>Clear</span>
                                            </button>
                                        </div>
                                    </b-datepicker>
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field label="Type">
                                    <b-input v-model="filterType" icon="keyboard"></b-input>
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field label="Person">
                                    <b-autocomplete v-model="filterPerson" ref="autocomplete" :data="filteredUsersArray"
                                        placeholder="e.g. Fritz" @select="option => selected = option" open-on-focus
                                        icon="user">
                                        <template slot="empty">No one named {{filterPerson}} here.</template>
                                    </b-autocomplete>
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field label="Room">
                                    <b-input v-model="filterRoom" icon="building"></b-input>
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field label="Computer">
                                    <b-input v-model="filterComputer" icon="desktop"></b-input>
                                </b-field>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <div class="section">
                <div class="container">
                    <div class="columns buttons">
                        <div class="column has-text-left is-half-tablet is-full-mobile is-3 is-showFilter">
                            <b-button size="is-medium" type="is-light" icon-left="filter" @click="toggleFilters"
                                expanded>
                                Filter list
                            </b-button>
                        </div>
                        <div class="column has-text-centered">
                            <b-button size="is-medium" type="is-warning" icon-left="box"
                                @click="onlyChecked=!onlyChecked" :disabled="!checkedRows.length" v-if="!onlyChecked">
                                Hide Done
                            </b-button>
                            <b-button size="is-medium" type="is-warning" icon-left="box-open"
                                @click="onlyChecked=!onlyChecked" :disabled="!checkedRows.length" v-else>
                                Show Done
                            </b-button>
                        </div>
                        <div class="column has-text-right is-half-tablet is-full-mobile is-3 is-newTodo">
                            <b-button size="is-medium" type="is-primary" icon-left="plus" @click="showTodoModal"
                                expanded>
                                New To-do
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import AddTodo from '@/components/AddTodo.vue'
import AddNote from '@/components/AddNote.vue'
export default {
    data() {
        return {
            checkedRowsDummy: [],
            showFilters: false,
            filterDates: null,
            filterType: "",
            filterPerson: "",
            filterRoom: "",
            filterComputer: "",
            isToggled: false,
            onlyChecked: true,
            note: ""
        }
    },
    components: {
        AddNote
    },
    computed: {
        isAdmin() {
            return this.$store.state.isAdmin
        },
        todos: {
            get() {
                if (this.$store.state.todos !== null) {
                    return this.$store.state.todos
                } else {
                    let todos= [{"Art":"Installation","Completed":false,"Date":"2020.4.3","Details":"more","Person":"Allan","Raum":"64","Rechner":"iMac","ID":"-M3zsteBb7cts08PYi9n"}]
                    return todos
                }
            },
            set(todos) {
                this.$store.dispatch("setTodos", todos)
            }
        },

        todosArrayByDate() {
            let todosArray = this.json2array(this.todos)
            if (this.filterDates !== null) {
                let dateArray = []
                for (let key in todosArray) {
                    // console.log(todosArray[key].date)
                    let dateString = todosArray[key].Date
                    let itemDate = new Date(this.dateToHuman(dateString))
                    let itemTime = itemDate.getTime()
                    let selStartDate = new Date(this.filterDates[0])
                    let selStart = selStartDate.getTime()
                    let selEndDate = new Date(this.filterDates[1])
                    let selEnd = selEndDate.getTime()
                    if ( itemTime >= selStart && itemTime <= selEnd + 86400000) {
                        dateArray.push(todosArray[key])
                    }
                }
                return dateArray
            } else {
                return todosArray
            }
        },
        
        todosArrayByType() {
            let todosArrayByDate = this.todosArrayByDate
            if (this.filterType !== "") {
                let typeArray = []
                for (let key in todosArrayByDate) {
                    if (todosArrayByDate[key].Art.includes(this.filterType)) {
                        typeArray.push(todosArrayByDate[key])
                    }
                }
                return typeArray
            } else {
                return todosArrayByDate
            }
        },

        todosArrayByPerson() {
            let todosArrayByType = this.todosArrayByType
            if (this.filterPerson !== "") {
                let personArray = []
                for (let key in todosArrayByType) {
                    if (todosArrayByType[key].Person.includes(this.filterPerson)) {
                        personArray.push(todosArrayByType[key])
                    }
                }
                return personArray
            } else {
                return todosArrayByType
            }
        },

        todosArrayByRoom() {
            let todosArrayByPerson = this.todosArrayByPerson
            if (this.filterRoom !== "") {
                let roomArray = []
                for (let key in todosArrayByPerson) {
                    if (todosArrayByPerson[key].Raum.includes(this.filterRoom)) {
                        roomArray.push(todosArrayByPerson[key])
                    }
                }
                return roomArray
            } else {
                return todosArrayByPerson
            }
        },
        todosArrayByComputer() {
            let todosArrayByRoom = this.todosArrayByRoom
            if (this.filterComputer !== "") {
                let computerArray = []
                for (let key in todosArrayByRoom) {
                    if (todosArrayByRoom[key].Rechner.toLowerCase().includes(this.filterComputer.toLowerCase())) {
                        computerArray.push(todosArrayByRoom[key])
                    }
                }
                return computerArray
            } else {
                return todosArrayByRoom
            }
        },
        todosArray() {
            return this.todosArrayByComputer
        },

        users: {
            get() {
                if (this.$store.state.users !== null) {
                    return this.$store.state.users
                } else {
                    let users= [{"Name":"Allan"}, {"Name":"Fritz"}]
                    return users
                }
            },
            set(users) {
                this.$store.dispatch("setTodos", users)
            }
        },

        filteredUsersArray() {
            return this.usersList.filter((option) => {
                return option
                    .toString()
                    .toLowerCase()
                    .indexOf(this.filterPerson.toLowerCase()) >= 0
            })
        },

        usersList() {
            let usersObject = this.users
            let usersArray = []
            let keys = Object.keys(usersObject)
            keys.forEach(function (key) {
                let userName = usersObject[key].Name
                // userName["ID"] = key
                usersArray.push(userName)
                // console.log(key)
                // console.log(userName)
            })
            return usersArray
        },

        checkedRows: {
            get() {
                let todos = this.todosArray
                let checkedArray = []

                for (let todo in todos) {
                    let currentTodo = todos[todo]
                    if (currentTodo.Completed == true) {
                        checkedArray.push(this.todosArray[todo])
                    }
                }
                // return [this.todosArray[0]]
                //console.log(checkedArray)
                return checkedArray
            },
            set(value) {
                this.checkedRowsDummy = value
            }
        },
        uncheckedRows: {
            get() {
                let todos = this.todosArray
                let checkedArray = []

                for (let todo in todos) {
                    let currentTodo = todos[todo]
                    if (currentTodo.Completed == false) {
                        checkedArray.push(this.todosArray[todo])
                    }
                }
                // return [this.todosArray[0]]
                //console.log(checkedArray)
                return checkedArray
            },
            set(value) {
                this.checkedRowsDummy = value
            }
        },
        detailed() {
            let todosArray = this.todosArray
            let detailedArray = []
            for (let i in todosArray) {
                detailedArray.push(todosArray[i].ID)
            }
            return detailedArray
        }
    },
    methods: {
        loadTodos() {
            this.$store.dispatch('loadTodos')
            .then((response) => {
                this.todos = response
            },
            error => {
                // Handle Errors here.
                let errorMessage = error;
                this.$buefy.toast.open({
                    message: errorMessage,
                    type: 'is-danger',
                    position: 'is-bottom',
                    duration: 6000
                })
            })
        },

        loadUsers() {
            this.$store.dispatch('loadUsers')
            .then((response) => {
                this.users = response
            },
            error => {
                // Handle Errors here.
                let errorMessage = error;
                this.$buefy.toast.open({
                    message: errorMessage,
                    type: 'is-danger',
                    position: 'is-bottom',
                    duration: 6000
                })
            })
        },

        json2array(json) {
            var result = []
            var keys = Object.keys(json)
            keys.forEach(function (key) {
                let jsonWithKey = json[key]
                jsonWithKey["ID"] = key
                result.push(jsonWithKey)
                // console.log(key)
                // console.log(jsonWithKey)
            })
            return result
        },

        toggle(row) {
            this.$refs.table.toggleDetails(row)
        },

        toggleAll() {
            this.isToggled = !this.isToggled
        },

        showRow(row) {
            let isOpen = undefined!==this.$refs.table?this.$refs.table.isActiveDetailRow(row):false
            let myClass = isOpen?"open":"closed"
            return myClass
        },

        showTodoModal() {
            this.$buefy.modal.open({
                parent: this,
                component: AddTodo,
                hasModalCard: true,
                trapFocus: true,
                canCancel: ['x', 'outside'],
                props: {"users":this.usersList}
            })
        },

        toggleFilters() {
            this.showFilters=!this.showFilters
        },

        filteredNotes(notes) {
            // console.log(notes)
            let spifiNotes = []
            notes.foreach (note => {
                if (note) {
                    spifiNotes.push(note)
                }
            });
            // console.log(spifiNotes)
            return spifiNotes
        },
        dateToHuman(dateString) {
            // Make date into string based on locale
            let dateArray = dateString.split(".")
            let day = dateArray[2]
            let month = dateArray[1] - 1
            let year = dateArray[0]
            let date = new Date(year,month,day)
            let dateHuman = date.toLocaleDateString()
            return dateHuman
        },
        dateToOrder(dateString) {
            // Make date into string based on locale
            let dateArray = dateString.split(".")
            let day = dateArray[2]
            let month = dateArray[1] - 1
            let year = dateArray[0]
            let date = new Date(year,month,day)
            let dateM = date.getTime()
            return dateM
        },
    },
    filters: {
        dateToHuman(dateString) {
            // Make date into string based on locale
            let dateArray = dateString.split(".")
            let day = dateArray[2]
            let month = dateArray[1] - 1
            let year = dateArray[0]
            let date = new Date(year,month,day)
            let dateHuman = date.toLocaleDateString()
            return dateHuman
        },
        orderToHuman(dateM) {
            let dateObject = new Date(dateM)
            let dateHuman = dateObject.toLocaleDateString()
            return dateHuman
        },
        timeToHuman(timeString) {
            let timeArray = timeString.split(":")
            let hour = timeArray[0]
            let minutes = timeArray[1]
            if (minutes < 10) {
                minutes = "0" + minutes
            }
            return hour + ":" + minutes
        }
    },
    mounted() {
        this.loadTodos()
        this.loadUsers()
    }
}
</script>

<style scoped>
.icon.open {
    transform: rotate(90deg);
}
.icon.closed {
    transform: none;
}
.media .media-content .media {
    padding-left: 1.25rem;
}
/* .media .media-content .media:before {
    content: "•";
    padding-right: 0.75rem;
} */
.field.is-centered.is-grouped-multiline.is-grouped {
    justify-content: center;
}
/* divgroup-multiline */
</style>